var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action",attrs:{"aria-label":'remark',"title":'remark',"id":"remark-button"},on:{"click":_vm.show}},[_c('i',[_vm._v("remark")]),_c('span',[_vm._v("remark")])])}
var staticRenderFns = []

export { render, staticRenderFns }